// const API_BASE = process.env.REACT_APP_API_BASE || '';
const API_BASE = 'https://fsoserver.onrender.com'; 

export const getContent = async (key) => {
  const res = await fetch(`${API_BASE}/api/content/${encodeURIComponent(key)}`);
  if (!res.ok) throw new Error('Sisällön haku epäonnistui');
  return res.json();
};

export const updateContent = async (key, body, token) => {
  const res = await fetch(`${API_BASE}/api/content/${encodeURIComponent(key)}` , {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ body })
  });
  if (!res.ok) throw new Error('Sisällön tallennus epäonnistui');
  return res.json();
};

export const loginAdmin = async (username, password) => {
  const res = await fetch(`${API_BASE}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
  if (!res.ok) throw new Error('Kirjautuminen epäonnistui');
  return res.json();
};

// module: API helpers
export const getLeaderboard = async (category) => {
  const res = await fetch(`${API_BASE}/api/leaderboard/${encodeURIComponent(category)}`);
  if (!res.ok) throw new Error('Failed to get leaderboard');
  return res.json();
};

export const updateLeaderboard = async (category, entries, token) => {
  const res = await fetch(`${API_BASE}/api/leaderboard/${encodeURIComponent(category)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ entries })
  });
  if (!res.ok) throw new Error('Failed to update leaderboard');
  return res.json();
};

export const updateLeaderboardSource = async (category, url, token) => {
  const res = await fetch(`${API_BASE}/api/leaderboard/${encodeURIComponent(category)}/source`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ url })
  });
  if (!res.ok) throw new Error('Failed to update leaderboard source');
  return res.json();
};

export const getVisibilities = async () => {
  const res = await fetch(`${API_BASE}/api/visibility`);
  if (!res.ok) throw new Error('Näkyvyyksien haku epäonnistui');
  return res.json();
};

export const updateVisibility = async (key, isVisible, token) => {
  const res = await fetch(`${API_BASE}/api/visibility/${encodeURIComponent(key)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ isVisible })
  });
  if (!res.ok) throw new Error('Näkyvyyden päivitys epäonnistui');
  return res.json();
};
